'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Button = require('../../Button/src/Button.js');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
require('../../Typography/src/Heading.js');
require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
var Text = require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');
var Calendar_module = require('../styles/Calendar.module.less.js');
var date = require('../utils/date.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Header = (props) => {
    const { month, className, onChange, ...restProps } = props;
    const cx = reactUtils.useStyles(Calendar_module.default);
    const classNames = cx(className, 'header');
    const handleChangeMonth = React__namespace.useCallback((event) => {
        onChange?.(event.currentTarget.dataset.direction);
    }, [onChange]);
    return (React__namespace.createElement(Space.Space, { size: 0, align: "center", justify: "space-between", className: classNames, ...restProps },
        React__namespace.createElement(Button.Button, { type: "button", color: "blue", variant: "text", "data-direction": "prev", onClick: handleChangeMonth },
            React__namespace.createElement(Icon.Icon, { strong: true, icon: React__namespace.createElement(reactIcons.ArrowLeft, null) })),
        React__namespace.createElement(Text.Text, { className: cx('current-month'), capitalize: true }, date.getMonthFormatted(month)),
        React__namespace.createElement(Button.Button, { type: "button", color: "blue", variant: "text", "data-direction": "next", onClick: handleChangeMonth },
            React__namespace.createElement(Icon.Icon, { strong: true, icon: React__namespace.createElement(reactIcons.ArrowRight, null) }))));
};
Header.displayName = 'Header';

exports.Header = Header;
//# sourceMappingURL=Header.js.map
